// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail, signOut } from "firebase/auth";
import { getFirestore, query, getDocs, collection, where, addDoc, getDoc, doc, setDoc, deleteDoc } from "firebase/firestore";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import { sendApplicationAcceptance, sendInvitationEmail, sendSignUpConfirmationEmail } from "../../emailjs";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

// PROD
const firebaseConfig = {
    apiKey: "AIzaSyC_SN8Nz8AMEcqFoQaLrBr3dB7vjbuM2RM",
    authDomain: "sociosleclab.firebaseapp.com",
    projectId: "sociosleclab",
    storageBucket: "sociosleclab.appspot.com",
    messagingSenderId: "738054159919",
    appId: "1:738054159919:web:3926b715aa68e0a9e810da"
};

// DEV
// const firebaseConfig = {
//     apiKey: "AIzaSyA3-EEFYbkLY8k0jfniZiNg_MV8WIzKuDs",
//     authDomain: "qr-leclab.firebaseapp.com",
//     projectId: "qr-leclab",
//     storageBucket: "qr-leclab.appspot.com",
//     messagingSenderId: "343775417541",
//     appId: "1:343775417541:web:f5ceab37372fe0667f8cac",
//     measurementId: "G-P3HZGS01H6"
// };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app, 'gs://qr-leclab.appspot.com')

const logInWithEmailAndPassword = async (email, password) => {
    try {
        await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
        alert(err.message);
    }
};

const registerWithEmailAndPassword = async (p) => {
    const q = query(collection(db, 'invitations'), where('email', '==', p.email))
    const docs = await getDocs(q);
    if (docs.docs.length < 1) return 'El email con el que intenta registrarse no posee invitación a socio. Para poder registrarse es necesario envíar primero una solicitud.'
    const res = await createUserWithEmailAndPassword(auth, p.email, p.password)
    const user = res.user;
    const userData = { ...p, type: docs.docs[0].data().type, status: 'active', isAdmin: false }
    delete userData['password']
    const docRef = doc(db, "users", user.uid)
    await setDoc(docRef, userData, { merge: true })
    await deleteDoc(doc(db, "invitations", docs.docs[0].id))
    sendSignUpConfirmationEmail(p.firstname, p.email)
    return 'Registro completado'
};

const sendPasswordReset = async (email) => {
    try {
        await sendPasswordResetEmail(auth, email);
        alert("Password reset link sent!");
    } catch (err) {
        console.error(err);
        alert(err.message);
    }
};

const logout = () => {
    signOut(auth);
};

const getUserInfo = async (uid) => {
    const docRef = doc(db, `users/${uid}`)
    const docSnap = await getDoc(docRef)
    return docSnap.data()
}

// SOCIOS //
const getInvitations = async () => {
    const q = query(collection(db, 'invitations'))
    const docSnap = await getDocs(q);
    const docs = docSnap.docs.map(doc => doc.data())
    return docs
}

const getApplications = async () => {
    const q = query(collection(db, 'applications'))
    const docSnap = await getDocs(q);
    const docs = docSnap.docs.map(doc => doc.data())
    return docs
}

const getPartners = async (filter) => {
    const q = query(collection(db, 'users'))
    const docsSnap = await getDocs(q)
    const docs = docsSnap.docs.map(doc => doc.data())
    return docs
}

const invitePartner = async (p) => {
    const q = query(collection(db, "users"), where("email", "==", p.email));
    const docs = await getDocs(q);
    if (docs.docs.length > 0) return 'Ya existe invitación para este email.'
    await addDoc(collection(db, "invitations"), { ...p });
    sendInvitationEmail(p.name, p.email)
    return 'Invitación creada.'
}

const updateInvitation = async (email, type) => {
    const q = query(collection(db, "invitations"), where("email", "==", email));
    const docs = await getDocs(q);
    if (docs.docs.length < 1) return 'No existe ningún email que coincida.'
    const docRef = doc(db, 'invitations', docs.docs[0].id)
    await setDoc(docRef, { type: type }, { merge: true });
    return 'Invitación actualizada.'
}

const deleteInvitation = async (email) => {
    const q = query(collection(db, "invitations"), where("email", "==", email));
    const docs = await getDocs(q);
    if (docs.docs.length < 1) return 'No existe ningún email que coincida.'
    await deleteDoc(doc(db, "invitations", docs.docs[0].id));
    return 'Invitación eliminada.'
}

const sendApplication = async (p) => {
    const q = query(collection(db, "applications"), where("email", "==", p.email));
    const docs = await getDocs(q)
    if (docs.docs.length > 0) return 'Ya existe una solicitud de usuario con esta información'
    await addDoc(collection(db, 'applications'), { ...p, type: 'Socio de Transito' });
    return 'Su solicitud ha sido enviada.'
}

const acceptApplication = async (p, type) => {
    const q = query(collection(db, "applications"), where("email", "==", p.email));
    const docs = await getDocs(q)
    if (docs.docs.length < 1) return 'Ha habido un problemilla'
    await addDoc(collection(db, "invitations"), { email: p.email, type })
    sendApplicationAcceptance(p.firstname, p.email)
    await deleteDoc(doc(db, 'applications', docs.docs[0].id))
    return 'Solicitud aceptada';
}

const deleteApplication = async (email) => {
    const q = query(collection(db, "applications"), where("email", "==", email));
    const docs = await getDocs(q);
    if (docs.docs.length < 1) return 'Operación no válida';
    const docRef = doc(db, 'applications', docs.docs[0].id);
    await deleteDoc(docRef);
    return 'Eliminada correctamente';
}

const updatePartnerType = async (email, type) => {
    const q = query(collection(db, "users"), where("email", "==", email));
    const docs = await getDocs(q);
    if (docs.docs.length !== 0) {
        let docRef = doc(db, 'users', docs.docs[0].id)
        await setDoc(docRef, { type: type }, { merge: true })
        return 'El usuario se ha actualizado correctamente'
    } else return
}

const disablePartner = async (email, status) => {
    const q = query(collection(db, "users"), where("email", "==", email));
    const docs = await getDocs(q);
    if (docs.docs.length < 1) return;
    const docRef = doc(db, 'users', docs.docs[0].id);
    await setDoc(docRef, { status: status }, { merge: true });
    return 'La cuenta ha sido actualizada correctamente';
}

const saveImage = async (imageAsFile) => {
    var imageName = imageAsFile.substring(imageAsFile.lastIndexOf('/'), imageAsFile.length)
    var path = `images${imageName}`
    const imageRef = ref(storage, path)
    uploadBytes(imageRef, imageAsFile).then.then((snapshot) => {
        console.log('Uploaded a blob or file!');
        console.log(snapshot)
    })
}

const getImage = async () => {
    const reference = ref(storage, 'images/IMG_20220423_213715.jpg')
    const image = await getDownloadURL(reference)
    return image
}

export {
    auth,
    db,
    storage,
    logInWithEmailAndPassword,
    registerWithEmailAndPassword,
    sendPasswordReset,
    logout,
    getUserInfo,
    getInvitations,
    getApplications,
    getPartners,
    invitePartner,
    updateInvitation,
    deleteInvitation,
    sendApplication,
    acceptApplication,
    deleteApplication,
    updatePartnerType,
    disablePartner,
    saveImage,
    getImage
};